export default __webpack_public_path__ + "static/media/angular.3a69a9e2.png";